<template>
  <ToastModal
    ref="modal"
    show-mobile-footer
    modal-id="PrivacyStatementModal"
    :width="800"
    :title="$t('PrivacyStatement.Content.Title')"
  >
    <div class="pt-5 md:pt-12">
      <p class="o-caption md:ota-body-light" v-html="$t('PrivacyStatement.Content.Description')" />
    </div>
    <PrivacyStatementComponent />
    <template v-slot:footer>
      <ToastModalFooter class="w-full" color="black" variant="outline" @click="onModalClose" />
    </template>
  </ToastModal>
</template>

<script>
import ToastModal from '@/components/ToastModal'
import ToastModalFooter from '@/components/ToastModal/ToastModalFooter'
import PrivacyStatementComponent from '@/components/PrivacyStatementComponent'

export default {
  name: 'PrivacyStatementModal',
  components: {
    ToastModal,
    PrivacyStatementComponent,
    ToastModalFooter
  },
  methods: {
    toggleActivation (isOpen = true) {
      this.$refs.modal.toggleActivation(isOpen)
    },
    onModalClose () {
      this.$refs.modal.onModalClose()
    }
  }
}
</script>

<style scoped lang="postcss">
>>> .privacy-statement-component {
  &-subject-title {
    @apply hidden;
  }
}
</style>
